import React, { Component } from 'react';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';

import { connect } from 'react-redux';

import { searchPersons } from "reducers/person/personActions";

class PersonTypeahead extends Component {

    componentDidMount() {
        this.props.onRef(this)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    constructor(props) {
        super(props);
        this.state = {
            allowNew: false,
            isLoading: false,
            multiple: false,
            useCache: false
        };
    }

    componentWillReceiveProps(nextProps) {
    }

    clearText() {
        this.refs.syncTypeAhead.getInstance().clear();
    }

    handleSearch = (query) => {

        console.log("handleSearch", query);

        this.setState({ isLoading: true });

        let promise = new Promise((resolve, reject) => {
            this.props.searchPersons(query, resolve, reject);
        });
        promise.then(() => {
            this.setState({
                isLoading: false
            });
        });
    }

    handleChange(personSelected) {
        console.log("handleChange personSelected", personSelected);
        if (personSelected == undefined) {
            personSelected = null;
        }
        this.props.handleChange(personSelected);
    }

    render() {
        return (
            <AsyncTypeahead
                {...this.state}
                disabled={this.props.disabled}
                bsSize={"medium"}
                ref="syncTypeAhead"
                options={this.props.persons}
                labelKey="completeName"
                minLength={3}
                onSearch={this.handleSearch}
                placeholder="Busca una persona"
                onChange={(selected) => this.handleChange(selected[0])}
                renderMenuItemChildren={(option, props) => (
                    <div key={option.id}> {option.completeName}  </div>
                )}
                selected={this.props.selection != null ? [this.props.selection] : null}
            />
        )
    }
}

const mapStateToProps = state => (
    {
        persons: state.person.items
    }
)

export default connect(mapStateToProps, { searchPersons })(PersonTypeahead)



// WEBPACK FOOTER //
// ./src/components/PersonTypeahead/PersonTypeahead.jsx